import { Modal } from 'antd';
import styled from 'styled-components';

export const PreviewWrapper = styled.div`
  margin: auto;
  position: relative;
  display: inline-block;
  .image,
  .image-item__error {
    width: 100px;
    min-width: 100px;
    height: 100px;
    border-radius: 5px;
  }
  &:hover {
    .overlay {
      visibility: visible;
    }
  }
  .overlay {
    position: absolute;
    top: 0px;
    left: 0px;
    right: 5px;
    bottom: 0px;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.3);
    visibility: hidden;
    &:hover {
      visibility: visible;
    }
    .anticon {
      color: #fff;
      font-size: 30px;
    }
  }
`;

export const ModalWrapper = styled(Modal)`
  .ant-modal-close {
    right: -15px;
    top: -15px;
    background: #fff;
    border: 1px solid #efefef;
    width: 30px;
    height: 30px;
    &:hover {
      background: #fff;
      border: 1px solid #efefef;
    }

    .ant-modal-close-x {
      width: 30px;
      height: 30px;
      font-size: 16px;
      font-style: normal;
      line-height: 30px;
    }
  }
`;
